<script lang="ts">
  import DashCard from '../shared/DashCard.svelte';
  import { Camas, type Cama } from '../../../lib/api';

  export type CamaLite = Pick<Cama, 'id' | 'numero' | 'estado' | 'servicio' | 'sala'>;

  let {
    camas: camasProp,
    onCamaClick,
    title = 'Mapa de camas',
  }: {
    camas?: CamaLite[];
    onCamaClick?: (c: CamaLite) => void;
    title?: string;
  } = $props();

  let camas = $state<CamaLite[]>([]);
  let error = $state<string | null>(null);
  let sel = $state<CamaLite | null>(null);

  function clase(estado: string) {
    const e = estado.toUpperCase();
    if (e === 'DISPONIBLE' || e === 'LIMPIA') return 'libre';
    if (e === 'SUCIA' || e === 'ASIGNADA') return 'limpieza';
    if (e === 'MANTENIMIENTO' || e === 'BLOQUEADA') return 'mantenimiento';
    return 'ocupada';
  }

  async function cargar() {
    if (camasProp?.length) {
      camas = camasProp;
      return;
    }
    error = null;
    try {
      camas = await Camas.list();
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  function click(c: CamaLite) {
    sel = c;
    onCamaClick?.(c);
  }

  $effect(() => {
    if (camasProp) camas = camasProp;
    else cargar();
  });
</script>

<DashCard {title} hint="{camas.length} camas">
  {#snippet actions()}
    <button type="button" class="btn-sm" onclick={cargar}>↻</button>
  {/snippet}
  {#if error}<p class="err">{error}</p>{/if}
  {#if camas.length === 0 && !error}
    <p class="empty">Sin camas registradas. Use «Cargar demo» en el panel admin.</p>
  {:else}
    <div class="dash-camas">
      {#each camas as c (c.id ?? c.numero)}
        <button
          type="button"
          class="dash-cama {clase(c.estado)}"
          class:sel={sel?.numero === c.numero}
          title="{c.numero} · {c.estado}{c.servicio ? ' · ' + c.servicio : ''}"
          onclick={() => click(c)}
        >{c.numero}</button>
      {/each}
    </div>
    <div class="dash-leyenda">
      <span><i class="dash-dot" style="background:#30a46c"></i> Libre</span>
      <span><i class="dash-dot" style="background:#e5484d"></i> Ocupada</span>
      <span><i class="dash-dot" style="background:#f5a623"></i> Limpieza / asignada</span>
      <span><i class="dash-dot" style="background:#8b8fa3"></i> Mantenimiento</span>
    </div>
    {#if sel}
      <p class="detail"><strong>{sel.numero}</strong> — {sel.estado}{#if sel.servicio} · {sel.servicio}{/if}{#if sel.sala} · sala {sel.sala}{/if}</p>
    {/if}
  {/if}
</DashCard>

<style>
  .btn-sm { border: 1px solid var(--glass-border); background: var(--glass-bg-card); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); border-radius: 999px; cursor: pointer; padding: 0.2rem 0.55rem; font-size: 0.78rem; color: var(--text-secondary); font-weight: 600; transition: all 0.2s; }
  .btn-sm:hover { background: var(--brand-surface); border-color: var(--brand-strong); color: var(--brand-deep); }
  .err, .empty { margin: 0; font-size: 0.85rem; color: var(--text-secondary); }
  .err { color: var(--danger); }
  .detail { margin: 0.65rem 0 0; font-size: 0.82rem; color: var(--text-secondary); }
  .dash-cama.sel { outline: 2px solid var(--brand); outline-offset: 2px; box-shadow: 0 0 12px rgba(124,58,237,0.4); }
</style>
